import { EXCEL_GRID_HEADER_CLASS_NAME } from "../constants/excel-like-grid.constants";
import type { ExcelGridVirtualTableHeadProps } from "../models/excel-grid-component-props.models";
import { omitInlineStyleProp } from "../utils/excel-like-grid-ui.utils";
import { twMerge } from "tailwind-merge";

export const ExcelGridVirtualTableHead = ({ className, ...props }: ExcelGridVirtualTableHeadProps) => {
  const tableHeadProps = omitInlineStyleProp(props);

  return <thead {...tableHeadProps} className={twMerge(EXCEL_GRID_HEADER_CLASS_NAME, className)} />;
};
